import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import Img1 from "./img1.png";
import Img2 from "./img2.png";
import Img3 from "./img3.png";
import "./support.css";

const Support = () => {
  return (
    <>
      <Navb />
      <div className="support">
        <img src={Img1} alt="Img1" />
        <img src={Img2} alt="Img2" />
        <img src={Img3} alt="Img3" />
      </div>
      <Footer />
    </>
  );
};

export default Support;
